// First-page (Phase 1) identity fields. These are authoritative from Phase 1/2
// and must never be overwritten by a restored answer snapshot when pre-filling a
// survey on back-navigation.
export const FIRST_PAGE_IDENTITY_KEYS = [
  'BusinessInformation_100_EffectiveDate_WORLD_EN',
  'BusinessInformation_100_Profession_WORLD_EN',
  'BusinessInformation_100_CustomerInfo_WORLD_EN',
  'BusinessInformation_100_State_WORLD_EN'
] as const;

const EFFECTIVE_DATE_KEY = 'BusinessInformation_100_EffectiveDate_WORLD_EN';

// Returns a shallow copy of `answers` with the first-page identity fields
// removed, so a restored snapshot only re-applies the questions the user
// actually edited on that page. Phase 2 new-business keeps EffectiveDate
// (editable there), so stripping it is opt-out via keepEffectiveDate.
export const stripFirstPageIdentityFields = (
  answers: Record<string, unknown>,
  { keepEffectiveDate = false }: { keepEffectiveDate?: boolean } = {}
): Record<string, unknown> => {
  const rest = { ...answers };
  for (const key of FIRST_PAGE_IDENTITY_KEYS) {
    if (keepEffectiveDate && key === EFFECTIVE_DATE_KEY) continue;
    delete rest[key];
  }
  return rest;
};
